import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'ly-callout',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './callout.component.html',
  styleUrl: './callout.component.scss',
})
export class CalloutComponent {
  @Input() type: 'info' | 'warning' | 'negative' | 'positive' | '' = '';
  @Input() icon = 'info';
  @Input() buttonText!: string;

  @Output() buttonClick = new EventEmitter<void>();

  onButtonClick() {
    this.buttonClick.emit();
  }
}
